import forge from 'node-forge'
import { RSAPublicKey } from './preset.js'
import env from './env';

const AppUA = {
  group: /meituangroup/,
  waimai: /meituanwaimai-c|takeoutnew/,
  waimaiB: /meituanwaimai(-b|business)/,
  'dianping-nova': /com\.dianping\./,
  conch: /conch/,
  movie: /movie/,
  QCSC: /qcsc\/com\.meituan/,
  weibo: /weibo/,
  weixin: /micromessenger/,
  mqq: /qq\//,
  alipay: /alipayclient/,
  daxiang: /xm/,
  saori: /saori/,
  moma: /moma/,
  retail: /iretail|retail\.c/,
  zhenguo: /phoenix/,
  mtmaicai: /com\.(baobaoaichi\.imaicai|meituan\.(imaicai\.ep|retail\.v\.android|retail\.v\.android))/,
}

function getApp(campaign, userAgent) {
  const appName = Object.keys(AppUA)
  const ua = (userAgent || navigator.userAgent).toLowerCase()
  for (const name of appName) {
    if (AppUA[name].test(ua)) {
      return name
    }
  }
  if (campaign) {
    const posA = campaign.indexOf('A') + 1
    const posB = campaign.indexOf('B')
    const endPos = posB === -1 ? campaign.length : posB
    return campaign.substring(posA, endPos)
  }
  return /titansx/.test(ua) ? 'unknown-app' : 'web'
}

export function AESEncrypt(mode, info) {
  const iv = new forge.util.ByteBuffer(new ArrayBuffer(16))
  if (mode === 'decrypt') {
    const data = forge.util.decode64(info.data)
    const cipher = forge.cipher.createDecipher('AES-CBC', info.key)
    cipher.start({ iv })
    cipher.update(forge.util.createBuffer(data, 'utf-8'))
    cipher.finish()
    return cipher.output
  }

  const base64 = forge.util.binary.base64
  const AESKey = forge.random.getBytesSync(32)
  const cipher = forge.cipher.createCipher('AES-CBC', AESKey)
  cipher.start({ iv })
  cipher.update(forge.util.createBuffer(info.data, 'utf8'))
  cipher.finish()
  const encryptInfo = base64.encode(
    forge.util.binary.hex.decode(cipher.output.toHex())
  )
  const publicKey = forge.pki.publicKeyFromPem(RSAPublicKey)
  const en = publicKey.encrypt(AESKey)
  const encrypt_key = forge.util.encode64(en)
  return {
    encryptInfo,
    encrypt_key,
    AESKey,
  }
}

export function sendRaptorPoint(position, duration) {
  window.Owl &&
    window.Owl.addPoint({
      position,
      duration,
    })
}

export function sendRaptorErr(name, msg, category, level = 'error') {
  window.Owl &&
    window.Owl.addError(
      {
        name,
        msg: typeof msg === 'object' ? JSON.stringify(msg, null, 4) : msg,
      },
      {
        category,
        level
      }
    )
}

export const paramsInfo = {
  token: '',
  uuid: '',
  encrypt_key: '',
  encrypt_params: JSON.stringify(['deviceId']),
  clientTime: Math.round(Date.now() / 1000),
  entry: 'home_h5',
  deviceId: '',
  platform: '',
  app: getApp(),
  appVersion: '',
  version: '9.0.0',
  fingerprint: '',
  cityId: '',
  AESKey: '',
}

let deviceId = ''

export function getCommonParams() {
  const KNBP = window.KNB.getPromiseInstance()
  return new Promise(async (resolve, reject) => {
    const promiseList = []
    if (!paramsInfo.token || !paramsInfo.uuid) {
      promiseList.push(
        KNBP.getUserInfo().then((user) => {
          paramsInfo.token = user.token
          paramsInfo.uuid = user.uuid
        })
      )
    }
    if (!deviceId || !paramsInfo.platform) {
      promiseList.push(
        KNBP.getDeviceInfo().then((result) => {
          const { os, idfv, idfa } = result
          deviceId = os === 'iOS' ? idfa : idfv
          paramsInfo.platform = os === 'iOS' ? 'iphone' : 'android'
        })
      )
    }
    if (!paramsInfo.appVersion) {
      promiseList.push(
        KNBP.getAppInfo().then((data) => {
          paramsInfo.appVersion = data.version
        })
      )
    }
    if (!paramsInfo.fingerprint) {
      promiseList.push(
        KNBP.getFingerprint().then((ret) => {
          paramsInfo.fingerprint = ret.fingerprint
        })
      )
    }
    if (!paramsInfo.cityId) {
      promiseList.push(
        KNBP.getCity().then((city) => {
          paramsInfo.cityId = city.cityId
        })
      )
    }
    if (promiseList.length) {
      await Promise.all(promiseList).catch(async (e) => {
        if (
          !paramsInfo.deviceId ||
          !paramsInfo.encrypt_key ||
          !paramsInfo.AESKey
        ) {
          const { encryptInfo, encrypt_key, AESKey } = AESEncrypt('encrypt', {
            data: deviceId,
          })
          paramsInfo.deviceId = encryptInfo
          paramsInfo.encrypt_key = encrypt_key
          paramsInfo.AESKey = AESKey
          reject(paramsInfo)
        }
      })
    }
    if (!paramsInfo.deviceId || !paramsInfo.encrypt_key || !paramsInfo.AESKey) {
      const { encryptInfo, encrypt_key, AESKey } = AESEncrypt('encrypt', {
        data: deviceId,
      })
      paramsInfo.deviceId = encryptInfo
      paramsInfo.encrypt_key = encrypt_key
      paramsInfo.AESKey = AESKey
    }
    resolve(paramsInfo)
  })
}

export function syncBarCodeOffline(methodID, params) {
  return new Promise((resolve, reject) => {
    let isTimeout = false
    const timeout = 2000
    setTimeout(() => {
      if (!isTimeout) {
        isTimeout = true
        reject()
      }
    }, timeout)

    if (env.isTitans) {
      window.KNB.ready(() => {
        const start = Date.now()
        window.KNB.use('pay.syncBarCodeOffline', {
          methodID,
          ...params,
          success: (res) => {
            const metricInst = window.Owl && window.Owl.MetricManager()
            metricInst &&
              metricInst.setTags({
                status: isTimeout ? 'timeout' : 'success',
                methodID,
              })
            metricInst &&
              metricInst.setMetric('native_bridge', Date.now() - start)
            if (isTimeout) {
              return
            }
            console.log(`Native Bridge Method ${methodID} success`)
            isTimeout = true
            resolve(res)
          },
          fail: (err) => {
            const metricInst = window.Owl && window.Owl.MetricManager()
            metricInst &&
              metricInst.setTags({
                status: isTimeout ? 'timeout' : 'fail',
                methodID,
              })
            metricInst &&
              metricInst.setMetric('native_bridge', Date.now() - start)
            if (isTimeout) {
              return
            }
            console.log(`【桥调用失败】：${JSON.stringify(err)}`)
            isTimeout = true
            if (!err.errorMsg && !err.errMsg) {
              sendRaptorErr('桥模式未知失败', err, 'customError')
            } else if (err.methodID !== 1) {
              sendRaptorErr(err.errorMsg || err.errMsg, err, 'customError')
            }
            reject(err)
          },
        })
      })
    } else {
      reject('')
    }
  })
}

export function getSystem() {
  if (typeof window === 'undefined') {
    return 'node'
  }
  const ua = navigator.userAgent.toLowerCase()
  if (/android/.test(ua)) return 'android'
  if (/ios|iphone|ipod|ipad/.test(ua)) return 'ios'
  if (/macintosh/.test(ua)) return 'mac'
  if (/windows/.test(ua)) return 'windows'
  return 'unknown'
}

export function getLocation() {
  return new Promise((resolve, reject) => {
    if (!env.isKNB) {
      reject('')
      return
    }
    window.KNB.ready(() => {
      window.KNB.getLocation({
        type: 'wgs84',
        cache: true,
        timeout: 1000,
        success: (data) => {
          resolve(`${data.lat}_${data.lng}`)
        },
        fail: (err) => {
          reject('')
        },
      })
    })
  })
}

export function updateOfflineSeed(flag) {
  switch (flag) {
    case 0:
      localStorage.setItem('unionQrCodeSeed', '')
      syncBarCodeOffline(8).catch(() => {})
      break
    case 1:
      syncBarCodeOffline(0).catch(() => {})
      break
    case 2:
      break
    default:
      break
  }
}

export function str2Hex(str) {
  return Array.from(str, (char) => char.charCodeAt(0).toString(16)).join('')
}

// 16进制转中文
export function hex2Str(hex) {
  let str = ''
  for (let i = 0; i < hex.length; i += 2) {
    str += String.fromCharCode(parseInt(hex.substr(i, 2), 16))
  }
  return decodeURIComponent(escape(str))
}
